<template>
  <div>
      <vue-headful title="Credimóvil | Comprar un auto "/>
      <menu-component></menu-component>
        <!-- Banner Area -->
      <section class="banner_area banner_area_car">
      <div class="container">
    		<h6></h6>
    	</div>
    </section>

    <section class=" content-card">
        <div class="container">
            <div class="features_b">
                <br>
                <div class="row">
                    <div class="col-auto mr-auto">
                        <h2 style="font-weight: 600;">{{ data.brand }} {{ data.model }}</h2>
                    </div>
                    <div class="col-auto ml-auto">
                        <h2 style="font-weight: 600; color: #2759ab;">${{ (data.price == 0 ? '--' : formatPrice(data.price)) }}</h2>
                    </div>
                </div>
            </div>
            <br>
            <hr class="hr-car">
            <br>
            <!-- <img class="image" v-for="(image, i) in images" :src="image" :key="i" @click="index = i"> -->
            
            <div class="row" >
                    <div class="col-lg-10 col-md-10 pb-3">
                        <img :src="images[0]" @click="index = 0; onOpen()" class="img-primary" >
                    </div>
                    <div class="col-lg-2 col-md-2">
                        <div v-for="(image, i) in images" :key="i">
                            <img :src="image" @click="index = i; onOpen()" class="img-secondary" v-if="i != 0 && i < 6">  
                        </div>
                    </div>
                    <vue-gallery-slideshow :images="images" :index="index" @close="index = null; onClose()"></vue-gallery-slideshow>

                    <div class="col-lg-12 pl-0 pr-0">
                        <div v-for="(video, i) in videos" :key="i" class="d-inline">
                            <video controls class="img-secondary pl-3" style="width: 18vw;">
                                <source :src="video">
                            </video>
                        </div>
                    </div>
            </div>
            <br>
            <div class="row">
                <div class="col-lg-12 col-md-12">
                    <div class="row">
                        <div class="col-lg-12 col-md-12">
                            <div class="tab">
                                <p class="title-tab">Detalles</p>
                            </div>
                            <hr class="hr-tab">
                        </div>
                        <div class="col-lg-12 col-md-12">
                            <div class="row">
                                <div class="col-lg-3 col-md-6 col-sm-12">
                                    <label class="detail-title">Marca</label>
                                    <p class="detail">{{data.brand}}</p>
                                </div>
                                <div class="col-lg-3 col-md-6 col-sm-12">
                                    <label class="detail-title">Modelo</label>
                                    <p class="detail">{{data.model}}</p>
                                </div>
                                <div class="col-lg-3 col-md-6 col-sm-12">
                                    <label class="detail-title">Kilometraje</label>
                                    <p class="detail">{{data.mileage}}</p>
                                </div>
                                <div class="col-lg-3 col-md-6 col-sm-12">
                                    <label class="detail-title">Combustible</label>
                                    <p class="detail">{{data.fuel}}</p>
                                </div>
                                <div class="col-lg-3 col-md-6 col-sm-12">
                                    <label class="detail-title">Año</label>
                                    <p class="detail">{{data.year}}</p>
                                </div>
                                <div class="col-lg-3 col-md-6 col-sm-12">
                                    <label class="detail-title">Condición del vehículo</label>
                                    <p class="detail">{{data.condition}}</p>
                                </div>
                                <div class="col-lg-3 col-md-6 col-sm-12">
                                    <label class="detail-title">Número de dueños</label>
                                    <p class="detail">{{data.owners}}</p>
                                </div>
                                <div class="col-lg-3 col-md-6 col-sm-12">
                                    <label class="detail-title">Color</label>
                                    <p class="detail">{{data.color}}</p>
                                </div>
                            </div>
                            <br>
                        </div>
                    </div>
                </div>
                <div class="col-lg-12 col-md-12">
                    <div class="row">
                        <div class="col-lg-12 col-md-12">
                            <div class="tab">
                                <p class="title-tab">Información técnica</p>
                            </div>
                            <hr class="hr-tab">
                        </div>
                        <div class="col-lg-12 col-md-12">
                            <div class="row">
                                <div class="col-lg-3 col-md-6 col-sm-12">
                                    <label class="detail-title">Tipo de motor</label>
                                    <p class="detail">{{data.motor}}</p>
                                </div>
                                <div class="col-lg-3 col-md-6 col-sm-12">
                                    <label class="detail-title">Descripción del motor</label>
                                    <p class="detail">{{data.motorDescription}}</p>
                                </div>
                                <div class="col-lg-3 col-md-6 col-sm-12">
                                    <label class="detail-title">Número de cilindros</label>
                                    <p class="detail">{{data.cylinders}}</p>
                                </div>
                                <div class="col-lg-3 col-md-6 col-sm-12">
                                    <label class="detail-title">Rendimiento en la ciudad</label>
                                    <p class="detail">{{data.performanceCity}}</p>
                                </div>
                                <div class="col-lg-3 col-md-6 col-sm-12">
                                    <label class="detail-title">Rendimiento en carretera</label>
                                    <p class="detail">{{data.performanceRoad}}</p>
                                </div>
                                <div class="col-lg-3 col-md-6 col-sm-12">
                                    <label class="detail-title">Capacidad del tanque</label>
                                    <p class="detail">{{data.tankCapacity}}</p>
                                </div>
                                <div class="col-lg-3 col-md-6 col-sm-12">
                                    <label class="detail-title">Número de pasajeros</label>
                                    <p class="detail">{{data.passengers}}</p>
                                </div>
                                <div class="col-lg-3 col-md-6 col-sm-12">
                                    <label class="detail-title">Transmisión</label>
                                    <p class="detail">{{data.transmission}}</p>
                                </div>
                            </div>
                            <br>
                        </div>
                    </div>
                </div>
                <div class="col-lg-12 col-md-12">
                    <div class="row">
                        <div class="col-lg-12 col-md-12">
                            <div class="tab">
                                <p class="title-tab">Equipamiento</p>
                            </div>
                            <hr class="hr-tab">
                        </div>
                        <div class="col-lg-12 col-md-12">
                            <table class="table table-striped">
                                <tbody>
                                    <tr>
                                        <td style="width: 70%;">Aire acondicionado</td>
                                        <td class="text-center">
                                            <img src="images/icons/check.svg" v-if="data.airConditioning">
                                            <img src="images/icons/close.svg" v-if="!data.airConditioning">
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="width: 70%;">Frenos ABS</td>
                                        <td class="text-center">
                                            <img src="images/icons/check.svg" v-if="data.abs">
                                            <img src="images/icons/close.svg" v-if="!data.abs">
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="width: 70%;">Asistencia de frenos</td>
                                        <td class="text-center">
                                            <img src="images/icons/check.svg" v-if="data.brakeAssistance">
                                            <img src="images/icons/close.svg" v-if="!data.brakeAssistance">
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="width: 70%;">Reproductor de CD</td>
                                        <td class="text-center">
                                            <img src="images/icons/check.svg" v-if="data.cdPlayer">
                                            <img src="images/icons/close.svg" v-if="!data.cdPlayer">
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="width: 70%;">Estereo USB</td>
                                        <td class="text-center">
                                            <img src="images/icons/check.svg" v-if="data.usbStereo">
                                            <img src="images/icons/close.svg" v-if="!data.usbStereo">
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="width: 70%;">Seguros eléctricos</td>
                                        <td class="text-center">
                                            <img src="images/icons/check.svg" v-if="data.electricalInsurance">
                                            <img src="images/icons/close.svg" v-if="!data.electricalInsurance">
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="width: 70%;">Bolsas de aire</td>
                                        <td class="text-center">
                                            <img src="images/icons/check.svg" v-if="data.airbags">
                                            <img src="images/icons/close.svg" v-if="!data.airbags">
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="width: 70%;">Asientos de cuero</td>
                                        <td class="text-center">
                                            <img src="images/icons/check.svg" v-if="data.leatherSeats">
                                            <img src="images/icons/close.svg" v-if="!data.leatherSeats">
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="width: 70%;">Ventanas eléctricas</td>
                                        <td class="text-center">
                                            <img src="images/icons/check.svg" v-if="data.electricWindows">
                                            <img src="images/icons/close.svg" v-if="!data.electricWindows">
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="width: 70%;">Cajuela automática</td>
                                        <td class="text-center">
                                            <img src="images/icons/check.svg" v-if="data.automaticTrunk">
                                            <img src="images/icons/close.svg" v-if="!data.automaticTrunk">
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="width: 70%;">Portavasos</td>
                                        <td class="text-center">
                                            <img src="images/icons/check.svg" v-if="data.cupHolder">
                                            <img src="images/icons/close.svg" v-if="!data.cupHolder">
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <br>
                        </div>
                    </div>
                </div>
                <div class="col-lg-12 col-md-12">
                    <div class="row">
                        <div class="col-lg-12 col-md-12">
                            <div class="tab">
                                <p class="title-tab">Descripción</p>
                            </div>
                            <hr class="hr-tab">
                        </div>
                        <div class="col-lg-12 col-md-12">
                            <p class="text-justify">
                                {{ data.publication.description }}
                            </p>
                            <br>
                        </div>
                    </div>
                </div>
                <div class="col-lg-12 col-md-12">
                    <div class="row">
                        <div class="col-lg-12 col-md-12">
                            <div class="tab">
                                <p class="title-tab">Financiamiento</p>
                            </div>
                            <hr class="hr-tab">
                        </div>
                        <div class="col-lg-12 col-md-12">
                            <form>
                                <div class="row">
                                    <div class="col-lg-3 col-md-6 col-sm-12">
                                        <h6>Enganche</h6>
                                        <span style="position: absolute;padding: 9px 16px;">$</span><input type="text" class="post_input" style="position: initial !important;" id="vehicleHitch" name="vehicleHitch" v-only-numbers v-model="formFinancing.vehicleHitch" v-on:keyup="money()" :class="{ 'error': $v.formFinancing.vehicleHitch.$invalid }" required>
                                        <span><small>Se necesita mínimo el 20% de enganche</small></span>
                                    </div>
                                    <div class="col-lg-3 col-md-6 col-sm-12">
                                        <h6>Plazo</h6>
                                        <select class="post_select" id="term" :class="{ 'error': $v.formFinancing.term.$invalid }">
                                            <option value="12">12 meses</option>
                                            <option value="24">24 meses</option>
                                            <option value="36">36 meses</option>
                                            <option value="48">48 meses</option>
                                        </select>
                                    </div>
                                    <div class="col-lg-3 col-md-6 col-sm-12">
                                        <h6>Monto a financiar</h6>
                                        <p class="detail">${{ (data.price == 0 ? '--' : formatPrice((data.price - formFinancing.vehicleHitch))) }}</p>
                                    </div>
                                    <div class="col-lg-3 col-md-6 col-sm-12">
                                        <h6>Cuota mensual</h6>
                                        <!-- <p class="detail">${{ (formFinancing.monthlyFee == 0 ? '--' : formatPrice(formFinancing.monthlyFee)) }}</p> -->
                                        <p class="detail">${{(data.price == 0 ? '--' : formatPrice(
                                            ((data.price - formFinancing.vehicleHitch) / formFinancing.term) + (((data.price - formFinancing.vehicleHitch) / 100) * 2.32) + 199 + 40))}}
                                        </p>
                                    </div>
                                    <div class="col-lg-12 col-md-12 col-sm-12 new_btn">
                                        <button class="align-bottom theme_btn btn" type="button" style="margin-top: 13px; float: right;" :disabled="$v.formFinancing.$invalid" v-on:click="initRequest()">
                                            Iniciar solicitud
                                        </button>
                                    </div>
                                </div>
                            </form>
                            <br>
                        </div>
                    </div>
                </div>
                <div class="col-lg-12 col-md-12">
                    <div class="row">
                        <div class="col-lg-12 col-md-12">
                            <div class="tab">
                                <p class="title-tab">Contacto</p>
                            </div>
                            <hr class="hr-tab">
                        </div>
                        <div class="col-lg-12 col-md-12 pb-5">
                            <br>
                            <div class="row m-0" style="background-color: rgb(241 241 241); padding: 20px">
                                <div class="row" v-if="data.publication.user.seller">
                                    <div class="col-lg-12 col-md-12 col-sm-12">
                                        <h5 style="font-weight: 600;">Infomación del vendedor</h5>
                                    </div>
                                    <div class="col-lg-3 col-md-6 col-sm-12 pt-3 d-flex flex-row justify-content-center bd-highlight" >
                                        <div class="bd-highlight align-self-center">
                                            <img src="images/icons/user.svg" class="img-contact">
                                        </div>
                                        <div class="bd-highlight align-self-center">
                                            <p class="p-contact">
                                                {{ data.publication.user.seller.loteName }}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-lg-3 col-md-6 col-sm-12 pt-3 d-flex flex-row justify-content-center bd-highlight" >
                                        <div class="bd-highlight align-self-center">
                                            <img src="images/icons/location.svg" class="img-contact">
                                        </div>
                                        <div class="bd-highlight align-self-center">
                                            <p class="p-contact" style="text-align: left;">
                                                {{ data.publication.user.seller.address }}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-lg-3 col-md-6 col-sm-12 pt-3 d-flex flex-row justify-content-center bd-highlight" >
                                        <div class="bd-highlight align-self-center">
                                            <img src="images/icons/phone.svg" class="img-contact">
                                        </div>
                                        <div class="bd-highlight align-self-center">
                                            <p class="p-contact">
                                                <a :href="'tel:' + data.publication.user.seller.tel1" style="color: black;">
                                                    {{ data.publication.user.seller.tel1 }}
                                                </a>
                                                <a :href="'tel:' + data.publication.user.seller.tel2" v-if="data.publication.user.seller.tel2" style="color: black;">
                                                    {{ data.publication.user.seller.tel2 }}
                                                </a>
                                                <a :href="'tel:' + data.publication.user.seller.tel3" v-if="data.publication.user.seller.tel3" style="color: black;">
                                                    {{ data.publication.user.seller.tel3 }}
                                                </a>
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-lg-3 col-md-6 col-sm-12 pt-3 d-flex flex-row justify-content-center bd-highlight" >
                                        <div class="bd-highlight align-self-center">
                                            <img src="images/icons/envelope.svg" class="img-contact">
                                        </div>
                                        <div class="bd-highlight align-self-center">
                                            <p class="p-contact">
                                                <a :href="'mailto:' + data.publication.user.seller.email" style="color: black;">
                                                    {{ data.publication.user.seller.email }}
                                                </a>
                                            </p>
                                        </div>
                                    </div>

                                </div>
                                <div class="row" v-if="!data.publication.user.seller">
                                    <div class="col-lg-12 col-md-12 col-sm-12">
                                        <h5 style="font-weight: 600;">Infomación del vendedor</h5>
                                    </div>
                                    <div class="col-lg-3 col-md-6 col-sm-12 pt-3 d-flex flex-row justify-content-center bd-highlight" >
                                        <div class="bd-highlight align-self-center">
                                            <img src="images/icons/user.svg" class="img-contact">
                                        </div>
                                        <div class="bd-highlight align-self-center">
                                            <p class="p-contact">
                                                Credimóvil
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-lg-3 col-md-6 col-sm-12 pt-3 d-flex flex-row justify-content-center bd-highlight" >
                                        <div class="bd-highlight align-self-center">
                                            <img src="images/icons/location.svg" class="img-contact">
                                        </div>
                                        <div class="bd-highlight align-self-center">
                                            <p class="p-contact" style="text-align: left;">
                                                Av. De las Rosas 2991, Guadalajara, Jalisco
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-lg-3 col-md-6 col-sm-12 pt-3 d-flex flex-row justify-content-center bd-highlight" >
                                        <div class="bd-highlight align-self-center">
                                            <img src="images/icons/phone.svg" class="img-contact">
                                        </div>
                                        <div class="bd-highlight align-self-center">
                                            <p class="p-contact">
                                                <a href="tel:3310782828" style="color: black;">3310782828</a>
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-lg-3 col-md-6 col-sm-12 pt-3 d-flex flex-row justify-content-center bd-highlight" >
                                        <div class="bd-highlight align-self-center">
                                            <img src="images/icons/envelope.svg" class="img-contact">
                                        </div>
                                        <div class="bd-highlight align-self-center">
                                            <p class="p-contact">
                                               <a href="mailto:contacto@gpiautocomercial.com" style="color: black;">contacto@gpiautocomercial.com</a>
                                            </p>
                                        </div>
                                    </div>

                                </div>
                                <div class="col-lg-12 col-md-12 col-sm-12 pt-3 pl-3">
                                    <h5 style="font-weight: 600;">Solicitar cotización</h5>
                                    <br>
                                    <div class="row bg-white p-3 m-0">
                                        <div class="col-lg-6 col-md-12 col-sm-12 pt-3">
                                            <input type="text" class="post_input" id="nameContact" name="name" placeholder="Nombre" v-model="formContact.name" :class="{ 'error': $v.formContact.name.$invalid }" required>
                                        </div>
                                        <div class="col-lg-3 col-md-6 col-md-12 pt-3">
                                            <input type="email" class="post_input" id="emailContact" name="email" placeholder="Correo electrónico" v-model="formContact.email" :class="{ 'error': $v.formContact.email.$invalid }" required>
                                        </div>
                                        <div class="col-lg-3 col-md-6 col-md-12 pt-3">
                                            <input type="tel" class="post_input" id="phoneContact" name="phone" placeholder="Teléfono" v-only-numbers v-model="formContact.phone" :class="{ 'error': $v.formContact.phone.$invalid }" required>
                                        </div>
                                        <div class="col-lg-3 col-md-6 col-md-12 select_from pt-3">
                                            <select class="post_select" id="gender" name="phone" placeholder="Sexo" v-model="formContact.gender" :class="{ 'error': $v.formContact.gender.$invalid }" required>
                                                <option value="male">Masculino</option>
                                                <option value="female">Femenino</option>
                                            </select>
                                        </div>
                                        <div class="col-lg-3 col-md-6 col-md-12 select_from pt-3">
                                            <div class="input-icons">
                                                <input readonly class="post_select" id="birthday" name="birthday" placeholder="Fecha de nacimiento" style="cursor: pointer">
                                                <i class="fa fa-angle-down icon" style="color: black" v-on:click=selectDate()></i>
                                            </div>
                                        </div>
                                        <div class="col-lg-3 col-md-6 col-md-12 select_from pt-3">
                                            <input type="tel" class="post_input" id="zipCode" name="zipCode" placeholder="Código postal" v-only-numbers v-model="formContact.zipCode" :class="{ 'error': $v.formContact.zipCode.$invalid }" required>
                                        </div>
                                        <div class="col-lg-3 col-md-6 col-md-12 select_from pt-3">
                                            <select class="post_select" id="person" name="person" placeholder="Tipo de persona" v-model="formContact.person" :class="{ 'error': $v.formContact.person.$invalid }" required>
                                                <option value="física">Física</option>
                                                <option value="moral">Moral</option>
                                            </select>
                                        </div>
                                        <!-- <div class="col-lg-12 col-md-12 col-md-12 pt-3">
                                            <input type="text" class="post_input" id="messageContact" name="messageContact" placeholder="Mensaje" v-model="formContact.message" :class="{ 'error': $v.formContact.message.$invalid }" required>
                                        </div> -->
                                        <div class="col-lg-12 col-md-12 col-md-12 new_btn">
                                            <button class="align-bottom theme_btn btn" type="button" style="margin-top: 13px; float: right;" :disabled="$v.formContact.$invalid" v-on:click="sendContact()">
                                                Enviar
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>


  </div>
</template>

<script>
import { required, minLength, between, minValue, maxValue } from 'vuelidate/lib/validators';
import VueGallerySlideshow from 'vue-gallery-slideshow';

var regexEmail = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$/;
var regexPhone = /^([0-9])*$/;

export default {
    name: 'BuyCar',
    components: {
        VueGallerySlideshow
    },
    data() {
        return {
            images: [
            ],
            videos: [],
            index: null,
            id: 0,
            data: {
                id: 0,
                userId: 0,
                brand: "",
                model: "",
                mileage: 0,
                fuel: "",
                year: 0,
                owners: 0,
                condition: "",
                color: "",
                price: 0,
                motor: "",
                motorDescription: "",
                cylinders: 0,
                performanceCity: 0,
                performanceRoad: 0,
                tankCapacity: 0,
                passengers: 0,
                transmission: "",
                airConditioning: true,
                abs: true,
                brakeAssistance: true,
                cdPlayer: true,
                usbStereo: true,
                electricalInsurance: true,
                airbags: true,
                leatherSeats: true,
                electricWindows: true,
                automaticTrunk: true,
                cupHolder: true,
                publication: {
                    description: '',
                    user: {
                        seller: {
                            loteName: '',
                            address: '',
                            tel1: '',
                            email: ''
                        }
                    }
                },
            },
            formFinancing: {
                vehicleHitch: 0,
                term: 12,
                monthlyFee: 0,
            },
            formContact: {
                name: '',
                email: '',
                phone: '',
                gender: 'female',
                birthday: '',
                zipCode: '',
                person: 'física',
	            origin: 'seller',
                message: '',
            }
        }
    },
    validations() {
        return {
            formFinancing: {
                vehicleHitch: { required, minValue: minValue((this.data.price/100)*20), maxValue: maxValue(this.data.price) },
                term: { required },
            },
            formContact: {
                name: { required },
                email: { required, validateEmail: (value) => { return regexEmail.test(value); } },
                phone: { required, validatePhone: (value) => { return regexPhone.test(value); } },
                gender: { required },
                zipCode: { required },
                person: { required },
                // message: { required },
            }
        }
    },
    methods: {
        refreshSelects() {
            // $('#term').niceSelect('update');
            $('#birthday').datepicker({
                dateFormat: 'dd-mm-yy',
                changeMonth: true,
                changeYear: true,
                yearRange: "-100:+0"
            });
        },
        selectDate() {
            $('#birthday').datepicker('show');
        },
        money() {

        },
        onChangeTerm() {
            setTimeout(() => {
            this.refreshSelects();
                $('#term').on('change', () => {
                    this.formFinancing.term = Number($('#term').val());
                    // this.refreshSelects();
                });
            }, 500)
            
        },
        initRequest() {
            // this.formFinancing.monthlyFee = ((data.price - formFinancing.vehicleHitch) / formFinancing.term) + (((data.price - formFinancing.vehicleHitch) / 100) * 2.32) + 199 + 40;
            let data = {
                vehicle_price: Number(this.data.price),
                vehicle_hitch: Number(this.formFinancing.vehicleHitch),
                months: Number(this.formFinancing.term),
                vehicle_model: this.data.year.toString(),
                vehicle_brand: this.data.brand,
                vehicle_version: this.data.model,
                vehicle_description: this.data.publication.description
            };

            this.$UserService.createCreditQuotation({data: data}).then((result) => {
                alert('¡Se han mandado sus datos con éxito!');
                window.location = '/pre-approval';
            }, (err) => alert(err.msg));
        },
        sendContact() {

            this.formContact.birthday = $('#birthday').val();

            if (!this.formContact.birthday) {
                alert('Favor de llenar los datos correspondientes');
                return;
            }

            this.formContact.gender = $('#gender').val();
            var arrayVehicles = [ this.data.id ];
            let data = {
                fullname: this.formContact.name,
                email: this.formContact.email,
                phone: this.formContact.phone,
                gender: this.formContact.gender,
                zipCode: this.formContact.zipCode,
                birthday: moment(this.formContact.birthday, 'DD-MM-YYYY').format('YYYY-MM-DD'),
                person: this.formContact.person,
                origin: this.formContact.origin,
                vehicles: arrayVehicles,
            };

            let id = 0;
            let dataInterest = {
                vehicleId: this.data.id,
                leadId: 0,
                status: 0,
                reason: 'Compra',
            };

            this.$VehicleService.newLead(data).then((result) => {
                id = result.data.id;
                dataInterest.leadId = id;
                this.$VehicleService.newInterest(this.data.id, id).then((result2) => {
                    this.$VehicleService.updateInterest(result2.data.id, dataInterest).then((result3) => {
                        alert('Éxito, enseguida un asesor se contactará con usted');
                        window.location = '/';
                    }, (err) => {
                        alert(err.message);
                    });
                }, (err) => {
                    alert(err.message);
                });
            },(err) => {
              alert(err.message);
            });
        },
        onOpen() {
            $('body').css({overflow: 'hidden'});
        },
        onClose() {
            $('body').css({overflow: 'auto'});
        },
        formatPrice(value) {
            let num = (value/1).toFixed(2);
            return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        getData() {
            if (!localStorage.getItem('vehicleId')) {
                window.location = '/buy-car';
            }
            this.id = localStorage.getItem('vehicleId');

            this.$VehicleService.getVehicle(this.id).then((result) => {
                this.data = result.data;
                this.images = [];
                this.data.images.forEach(img => {
                    if (this.validateImage(img.url)) {
                        this.images.push(img.url);
                    } else {
                        this.videos.push(img.url);
                    }
                });
            }, (err) => {
                alert(err.message);
                window.location = '/buy-car';
            })
            
        },
        validateImage(item) {
            if (item.includes('.mp4')) {
                return false;
            } else {
                return true;
            }
        }
    },
    created() {
        this.getData();
        this.onChangeTerm();
        // this.refreshSelects();
    },

}
</script>

<style lang="scss">

    .error {
        border-color: red !important;
    }
    .post_input{
        position: relative;
        background: #fff;
        border: 1px solid #eaeaea;
        box-shadow: none;
        outline: none;
        font: 400 16px/40px "Source Sans Pro", sans-serif;
        padding: 0 25px;
        height: auto;
        border-radius: 5px;
        color: rgba(0, 0, 0, 0.6);
        min-width: 100%;
    }

    .post_select {
        position: relative;
        background: #fff;
        border: 1px solid #eaeaea;
        box-shadow: none;
        outline: none;
        font: 400 16px/40px "Source Sans Pro", sans-serif;
        padding: 0 25px;
        height: 44px;
        border-radius: 5px;
        color: rgba(0, 0, 0, 0.6);
        min-width: 100%;
    }

    .input-icons {
        width: 100%;
        margin-bottom: 0px;
        i {
            position: absolute;
            bottom: 4px;
            right: 8px;
            cursor: pointer;
        }
    }

    .hr-car {
        width: 100%;
        border-top: 2px solid #bfbfbf;
    }

    .vgs__container {
        top: 75px
    }
    .img-primary {
        width: 100%;
        height: 91vh;
        // object-fit: contain;
        cursor: pointer;
    }
    .img-secondary {
        width: 100%;
        padding-bottom: 10px;
        // object-fit: contain;
        cursor: pointer;
    }
    .img-none {
        display: none;
    }
    .tab {
        background-color: #2759ab;
        color: white;
        font-size: 20px;
        font-weight: 600;
        width: max-content;
        height: 40px;
        border-radius: 10px 10px 0px 0px;
    }
    .title-tab {
        color: white;
        font-size: 20px;
        font-weight: 600;
        padding: 8px 25px 10px 25px;
    }
    .hr-tab {
        border: 0px;
        border-top: 3px solid #2759ab;
        width: 100%;
        margin-top: 0px;
    }
    .detail {
        color: black;
        font-size: 18px;
    }
    .detail-title {
        color: rgba(0, 0, 0, 0.702);
    }
    .p-contact {
        font-size: 20px; 
        color: black;
        text-align: justify;
    }
    .img-contact {
        margin-right: 10px; 
        width: 25px;
    }
    .new_btn {
        .theme_btn {
            background: #f59019;
            &:before {
                background: #2759ab;
            }
        }
    }

    .modal-slideshow__container {
        top: 6rem !important;
    }
</style>


// WEBPACK FOOTER //
// src/views/ViewCar.vue